/** @format */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl:
    process.env.REACT_APP_RESOURCES_API_URL ??
    "https://api.dev.resources.wjec.co.uk/",
  credentials: "include",
});

// createApi called api which handles tags Resources and User.
// aditional apis will be injected.
export const api = createApi({
  reducerPath: `api`,
  baseQuery: baseQuery,
  tagTypes: [
    "Resource",
    "User",
    "Lesson",
    "SubLesson",
    "Card",
    "ResourceStatus",
  ],
  endpoints: (builder) => ({
    getStatus: builder.query({
      query: () => "/status",
    }),
  }),
});

export const { useGetStatusQuery } = api;
